import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Share2 } from 'lucide-react';
import { ShareCasoDialog } from './ShareCasoDialog';
import { SharedCasoMembers } from './SharedCasoMembers';

interface CasoShareSectionProps {
  casoId: string;
  casoTitle: string;
}

export function CasoShareSection({ casoId, casoTitle }: CasoShareSectionProps) {
  const [shareDialogOpen, setShareDialogOpen] = useState(false);

  return (
    <>
      <div className="caso-share-section">
        <SharedCasoMembers casoId={casoId} maxVisible={3} />

        <Button
          variant="outline"
          size="sm"
          onClick={() => setShareDialogOpen(true)}
          className="caso-share-btn"
          data-tour="caso-share-btn"
        >
          <Share2 className="h-4 w-4 mr-2" />
          Compartilhar
        </Button>
      </div>

      <ShareCasoDialog
        open={shareDialogOpen}
        onOpenChange={setShareDialogOpen}
        casoId={casoId}
        casoTitle={casoTitle}
      />
    </>
  );
}
